import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { Page } from '../../_core/_interface/page';
import { Item } from '../../_core/_interface/item';
import { User } from '../../_core/_interface/user';
import { AuthService } from '../../_services/auth.service';
import { slideRight } from 'src/app/animations';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-n-menu-page-with-link',
  templateUrl: './n-menu-page-with-link.component.html',
  styleUrls: ['./n-menu-page-with-link.component.scss']
})
export class NMenuPageWithLinkComponent implements OnInit {
  parentCollection = "";
  items: Page[] = [];
  @Input()
  // parentId: string;
  selectedItem;
  showPage;
  itemToEdit: Item;
  autoPlay = false;
  showThumbs = false;
  collection = 'pages/';
  activeGalTypeClass: string;
  classOfGalleryType: string[] = ['files', 'scroll', 'simple'];
  galleryType = "";
  user: User;
  activeMobileMenu: boolean;
  compositeDesign: boolean = false;
  unika: boolean = false;

  @Output()
  public showMenuGalTrigger = new EventEmitter();
  itemContent: boolean = false;

  @Output() closeSubMenu = new EventEmitter<boolean>();

  galleryId: string;

  @Input()
  public parentId;
  @Input()
  public outOfGalleryMenu;
  @Input()
  public galleryIdInput;
  urlSwitcher: string = '';
  currentLanguage: string = 'he';

  constructor(private dataService: DataService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    if (this.route.snapshot.queryParams.lang) {
      this.currentLanguage = this.route.snapshot.queryParams.lang;
    }
    this.user = this.auth.currentUserValue;
    if (this.parentId !== undefined && this.parentId !== "") {
      this.dataService.getPagesWithLink(this.parentId).subscribe(items => {
        if (window.innerWidth > 1200) {
          if (this.outOfGalleryMenu) {
            this.items = items.filter(item => item.outOfGalleryMenu);
          } else {
            this.items = items.filter(item => !item.outOfGalleryMenu);
          }
        } else {
          this.items = items
        }
        // this.items = items;
        console.log("pages-with-linksN", items);
        if (this.items.length < 1) {
          this.showMenuGalTrigger.emit(false);
        }
        if (this.route.firstChild) {
          this.selectedItem = items.filter(gallery => gallery.id === this.route.firstChild.snapshot.params.galleryId);
        } else {
          this.selectedItem = items.filter(gallery => gallery.id === this.route.snapshot.params.galleryId);
        }
        this.selectedItem = this.selectedItem[0];
      });
    }
  }
  ngOnDestroy() {
    this.selectedItem = {};
  }


  changeTypeGallery(event) {
    this.galleryType = event.value;
  }

  listClick(event, newValue) {

    if (this.route.firstChild) {
      this.router.navigate([this.urlSwitcher + this.route.firstChild.snapshot.params.id + '/' + this.parentId + '/galleryD/' + this.parentId + '/' + newValue.id], {
        queryParams: { lang: this.currentLanguage },
        queryParamsHandling: 'merge' // Merges with any existing query params in the URL
      });

    } else {
      this.router.navigate([this.urlSwitcher + this.route.snapshot.params.id + '/' + this.parentId + '/galleryD/' + this.parentId + '/' + newValue.id], {
        queryParams: { lang: this.currentLanguage },
        queryParamsHandling: 'merge' // Merges with any existing query params in the URL
      });

    }
    this.selectedItem = newValue;
    this.closeSubMenu.emit(false);
  }
  changeAutoPlay(item) {
    this.autoPlay = !this.autoPlay
  }

  changeShowThumbs(item) {
    this.showThumbs = !this.showThumbs
  }
  closeEdit() {
    this.selectedItem = {};
    this.closeSubMenu.emit(false);
  }
}

